<div class="container">
  <div class="row">
    @if (sidenavContent) {
      <div class="col-md-2 sidenav">
        <ng-container *ngTemplateOutlet="sidenavContent"></ng-container>
      </div>
    }
    <main class="col" [attr.aria-label]="'content.primary-page-content' | translate">
      <div class="container ps-0 pe-0">
        <ng-container *ngTemplateOutlet="mainContent"></ng-container>
      </div>
    </main>
  </div>
</div>
